import React, { useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

function insertNullGaps(data, expectedIntervalMs, factor) {
  expectedIntervalMs = expectedIntervalMs || 60 * 60 * 1000; // hourly
  factor = factor || 1.5; // break if > 1.5x interval
  if (!data || !data.length) return data;

  var threshold = expectedIntervalMs * factor;
  var out = [data[0]];
  for (var i = 1; i < data.length; i++) {
    var prevX = out[out.length - 1][0];
    var x = data[i][0];
    var y = data[i][1];
    if (x - prevX > threshold) out.push([prevX + 1, null]); // force a break
    out.push([x, y]);
  }
  return out;
}

export default function Co2Chart({ data, xAxis, loading = false }) {
  const chartRef = useRef(null);

  React.useEffect(() => {
    if (chartRef.current) {
      const chart = chartRef.current.chart;
      if (loading) {
        chart.showLoading('Loading data...');
      } else {
        chart.hideLoading();
      }
    }
  }, [loading]);

  const options = {
    chart: { zooming: { type: 'x' } },
    credits: { enabled: false },
    legend: { enabled: true },
    title: { text: 'CO₂ Concentration', align: 'left' },
    lang: { noData: 'No data found in this range' },
    time: { timezone: 'Europe/Copenhagen' },
    xAxis,
    yAxis: { title: { text: 'ppm' } },
    tooltip: {
      shared: true,
      formatter: function () {
        let s = `<b>${Highcharts.dateFormat(
          '%Y-%m-%d %H:%M',
          this.x,
        )}</b><br/>`;
        this.points.forEach((point) => {
          const unit = point.series.userOptions.unitLabel || 'ppm';
          s += `<span style="color:${point.color}">●</span> ${
            point.series.name
          }: <b>${point.y.toFixed(2)} ${unit}</b><br/>`;
        });
        return s;
      },
    },
    series: data.map((series) => ({
      name: series.name,
      data: insertNullGaps(series.data, 60 * 60 * 1000, 1), // insert nulls if gap > 2 hours
      unitLabel: series.unitLabel || 'ppm',
      type: 'line',
    })),
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ style: { height: 250, margin: 10 } }}
      ref={chartRef}
    />
  );
}
